import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { setAppLocale } from '@/i18n'
import { useTenantStore } from '@/stores/tenant'
import type { Locale } from '@/config/tenants'

export function useLocale() {
  const { locale } = useI18n()
  const tenantStore = useTenantStore()

  const current = computed(() => locale.value as Locale)
  const available = computed(() => tenantStore.current.supportedLocales)

  function set(next: Locale): void {
    if (available.value.includes(next)) {
      setAppLocale(next)
    }
  }

  return { current, available, set }
}
